import { io } from 'socket.io-client';
//require('dotenv').config();

const backendURL = process.env.REACT_APP_BACKEND_URL;
console.log("BACKEND_URL = ",backendURL)
const socket = io(`${backendURL}`);

export default socket;
